import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Legal.scss';
import SEO from '../../components/SEO';
const PrivacyPolicy = () => {
    const { t } = useTranslation();
    useEffect(() => { window.scrollTo(0, 0); }, []);

    const s2Items = t('legal.privacy.s2_items', { returnObjects: true });
    const s3Items = t('legal.privacy.s3_items', { returnObjects: true });
    const s5Items = t('legal.privacy.s5_items', { returnObjects: true });

    return (
        <div className="kanem-legal-page">
            <SEO title="Politique de confidentialité" description="Politique de confidentialité de KANEM. Comment nous collectons, utilisons et protégeons vos données personnelles." url="/politique-confidentialite" />

            <div className="kanem-legal-hero">
                <div className="kanem-grain"></div>
                <div className="kanem-legal-hero-content">
                    <p className="kanem-eyebrow">{t('legal.eyebrow')}</p>
                    <h1 className="kanem-legal-title">{t('legal.privacy_title')}</h1>
                    <p className="kanem-legal-date">{t('legal.last_updated')}</p>
                </div>
            </div>

            <div className="kanem-legal-body">
                <div className="kanem-legal-inner">

                    <section className="kanem-legal-section">
                        <h2>{t('legal.privacy.s1_title')}</h2>
                        <p>{t('legal.privacy.s1_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.privacy.s2_title')}</h2>
                        <p>{t('legal.privacy.s2_desc')}</p>
                        <ul>
                            {Array.isArray(s2Items) && s2Items.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                        <p>{t('legal.privacy.s2_note')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.privacy.s3_title')}</h2>
                        <p>{t('legal.privacy.s3_desc')}</p>
                        <ul>
                            {Array.isArray(s3Items) && s3Items.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                        <p>{t('legal.privacy.s3_note')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.privacy.s4_title')}</h2>
                        <p>{t('legal.privacy.s4_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.privacy.s5_title')}</h2>
                        <p>{t('legal.privacy.s5_desc')}</p>
                        <ul>
                            {Array.isArray(s5Items) && s5Items.map((item, i) => <li key={i}>{item}</li>)}
                        </ul>
                        <p>{t('legal.privacy.s5_note')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.privacy.s6_title')}</h2>
                        <p>{t('legal.privacy.s6_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.privacy.s7_title')}</h2>
                        <p>{t('legal.privacy.s7_desc')}</p>
                    </section>

                    <section className="kanem-legal-section">
                        <h2>{t('legal.privacy.s8_title')}</h2>
                        <p>{t('legal.privacy.s8_desc')} <Link to="/contact">{t('legal.privacy.s8_link')}</Link>.</p>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
